<template>
  <v-toolbar class="escalon-dialog-header" 
  elevation="0" 
  height="35"
  :style="borderStyle">
    <img
      class="modal-axis-logo mr-2"
      :src="require('../../assets/' + coloredLogo)" />
    <span>{{text}}</span>
    <v-spacer/>
    <span>{{patientHeader}}</span>
    <v-spacer/>
    <close-button @click.stop.prevent="$emit('closeModal')" />
  </v-toolbar>
</template>

<script>
import { mapGetters } from "vuex";
import closeButton from "../controls/CloseButton";
export default {
  name: "multiviewBrowserHeader",
  components: { closeButton },
  props: {
    text: { type: String, default: "Multi View" }
  },
  computed: {
    ...mapGetters(["patient"]),
    patientHeader() {
      return this.patient && 
      (
        this.patient.ptId +
        " " +
        this.patient.lastName +
        ", " +
        this.patient.firstName
      );
    }
  }
}
</script>
